import React, { useState } from "react";
import { Tree, Checkbox, Space } from "antd";
import { initialData } from "./PermissionMenu";

const getAllKeys = (nodes) => {
  let keys = [];
  nodes.forEach((node) => {
    keys.push(node.key);
    if (node.children) {
      keys = keys.concat(getAllKeys(node.children));
    }
  });
  return keys;
};

const TreeNode = ({ node, onToggle }) => {
  const [expanded, setExpanded] = useState(true);

  const handlePermissionChange = (type, value) => {
    console.log(node.slug, type, value, "Toggle Data ?? FK");
    onToggle(node.slug, type, value);
  };

  return (
    <div style={{ marginLeft: "20px", marginTop: "5px" }}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "10px",
          borderRadius: "8px",
          border: "1px solid #ddd",
          background: "#fff",
          boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          {node.children && node.children.length > 0 && (
            <span
              style={{ cursor: "pointer", fontWeight: "bold" }}
              onClick={() => setExpanded(!expanded)}
            >
              {expanded ? "▼" : "▶"}
            </span>
          )}
          <span style={{ fontWeight: 500 }}>{node.title}</span>
        </div>
        <div style={{ display: "flex", gap: "10px" }}>
          <label>
            <input
              type="checkbox"
              checked={node.permissions.read}
              onChange={(e) => handlePermissionChange("read", e.target.checked)}
            />{" "}
            Read
          </label>
          <label>
            <input
              type="checkbox"
              checked={node.permissions.write}
              onChange={(e) =>
                handlePermissionChange("write", e.target.checked)
              }
            />{" "}
            Write
          </label>
          <label>
            <input
              type="checkbox"
              checked={node.permissions.edit}
              onChange={(e) => handlePermissionChange("edit", e.target.checked)}
            />{" "}
            Edit
          </label>
          <label>
            <input
              type="checkbox"
              checked={node.permissions.delete}
              onChange={(e) =>
                handlePermissionChange("delete", e.target.checked)
              }
            />{" "}
            Delete
          </label>
          <label>
            <input
              type="checkbox"
              checked={node.permissions.download}
              onChange={(e) =>
                handlePermissionChange("download", e.target.checked)
              }
            />{" "}
            Download
          </label>
        </div>
      </div>

      {expanded &&
        node.children &&
        node.children.map((child, index) => (
          <TreeNode key={child.key + index} node={child} onToggle={onToggle} />
        ))}
    </div>
  );
};

// Update tree correctly without overwriting siblings
const togglePermission = (nodes, key, type, value) => {
  const update = (node) => {
    let updatedNode = { ...node };

    if (node.slug === key) {
      // Update this node
      updatedNode.permissions = { ...node.permissions, [type]: value };

      // Propagate to all children
      if (node.children) {
        updatedNode.children = node.children.map((updateChild) =>
          propagateToChildren(updateChild, type, value)
        );
      }
    } else if (node.children) {
      updatedNode.children = node.children.map(update);

      // Auto-select parent if any child is selected
      updatedNode.permissions[type] = updatedNode.children.some(
        (child) => child.permissions[type]
      );
    }

    return updatedNode;
  };

  // Helper function to toggle all children recursively
  const propagateToChildren = (node, type, value) => {
    let updatedChild = {
      ...node,
      permissions: { ...node.permissions, [type]: value },
    };
    if (node.children) {
      updatedChild.children = node.children.map((child) =>
        propagateToChildren(child, type, value)
      );
    }
    return updatedChild;
  };

  return nodes.map(update);
};

export default function CustomTree({ treeData, setTreeData }) {

  const handleToggle = (key, type, value) => {
    setTreeData(togglePermission(treeData, key, type, value));
    console.log(togglePermission(treeData, key, type, value), "inside toggle callback");
  };

  return (
    <div style={{ margin: "auto" }}>
      {treeData.map((node) => (
        <TreeNode key={node} node={node} onToggle={handleToggle} />
      ))}
    </div>
  );
}
